import { useQuery } from "@apollo/client";
import { PERSON_BY_ID_QUERY } from "../../../../../api/person/queries";
import { personKlienterklaeringForm } from "../../../../../config/form/person/personKlienterklaeringFormConfig";
import { getHeaderActiveColumns, TD } from "../../../../../util/table";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import DocumentIcon from "../../../../icons/DocumentIcon";
import { ModalProvider } from "../../../../Modal/Modal";
import TableBasic, { TableRow } from "../../../../Table/TableBasic";
import DocumentModal from "../../../../Modal/modals/DocumentModal";
import IngenRegistreringer from "../IngenRegistreringer";
import OpretNyButtonBlock from "../OpretNyButtonBlock";
import {
  PersonDto,
  PersonKlienterklaering,
} from "../../../../../interfaces/schema";
import { PersonKlienterklaeringField } from "../../../../../interfaces/personer";
import { IColumn, SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import TLinkButton from "../../../../popover/TLinkButton";
import { orderBy } from "../../../../../util/orderBy";

export default function Klientkontoerklaering({
  columns,
  defaultColumns,
  invalidateData,
  personId,
  personKlientErklaering,
  setActiveColumns,
}: {
  personId: string;
  invalidateData: InvalidateDataFunction<any>;
  personKlientErklaering: PersonKlienterklaering[];
  defaultColumns: IColumn<PersonKlienterklaeringField>[];
  columns: IColumn<PersonKlienterklaeringField>[];
  setActiveColumns: React.Dispatch<
    React.SetStateAction<PersonKlienterklaeringField[]>
  >;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const isAuth = hasPermission(user, "TilsynWrite");
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "personKlientkontoerklaeringSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );

  const { data } = useQuery<{
    person: PersonDto;
  }>(PERSON_BY_ID_QUERY(), {
    variables: { id: personId },
  });

  // event handlers
  function downloadHandler() {
    tableToXLSX(columns, personKlientErklaering, {
      fileName: `klientkontoerklæring-for-${data?.person.kundeNr}`,
      additionalData: {
        kundenr: data?.person.kundeNr,
      },
    });
  }

  if (!personKlientErklaering.length) {
    return (
      <IngenRegistreringer
        editConfig={
          isAuth ? personKlienterklaeringForm(personId, undefined) : undefined
        }
        invalidateData={invalidateData}
      />
    );
  }
  return (
    <>
      <ButtonDownload onClick={downloadHandler} />
      <ModalProvider>
        <TableBasic
          columns={columns}
          setActiveColumns={setActiveColumns}
          defaultColumns={defaultColumns}
          headerRow={
            <>
              {getHeaderActiveColumns(columns, {
                defaultSortBy,
                setSortBy,
                sortBy,
              })}

              <th scope="col">Link</th>
              <th scope="col">Erklæring</th>
            </>
          }
        >
          {orderBy(
            personKlientErklaering,
            sortBy.map((ds) => ds.field),
            sortBy.map((ds) => ds.direction),
          ).map((ke, i) => {
            const editConfig = personKlienterklaeringForm(personId, ke.id, ke);
            return (
              <TableRow
                key={i}
                editConfig={isAuth ? editConfig : undefined}
                invalidateData={invalidateData}
              >
                <>
                  {columns
                    .filter((col) => col.active)
                    .map((col) => {
                      return <TD key={col.field} col={col} rowData={ke} />;
                    })}
                </>
                <td>
                  {!ke.erklModtaget &&
                    ke.klienterklaeringStatusNavigation?.nr ===
                      "FRIST_ORDINAER" && (
                      <TLinkButton
                        id={ke.id}
                        erklaeringtype="klienterklaering"
                      />
                    )}
                </td>
                <td>
                  {editConfig.getDocument && (
                    <DocumentModal
                      getDocument={editConfig.getDocument}
                      downloadLink={editConfig.downloadLink}
                      title={
                        <>
                          <DocumentIcon height={20} />
                          Klientkontoerklæring
                        </>
                      }
                      buttonContents={[
                        <DocumentIcon key={1} />,
                        <span key={2}>Vis erklæring</span>,
                      ]}
                      contentProps={{
                        className: "c-document c-document--klienterklaering",
                      }}
                    />
                  )}
                </td>
              </TableRow>
            );
          })}
        </TableBasic>
      </ModalProvider>
      <OpretNyButtonBlock
        editConfig={
          isAuth ? personKlienterklaeringForm(personId, undefined) : undefined
        }
        invalidateData={invalidateData}
      />
    </>
  );
}
const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "erklAar",
  },
  {
    direction: "desc",
    field: "periode.erklModtaget",
  },
];
